import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DocumentTemplate, DocumentTemplateCreate, DocumentTemplateFilter } from '../data/documentTemplate';

export function createDocumentTemplateService(client: AxiosInstance) {
  return createCrudService<DocumentTemplate, DocumentTemplateCreate, DocumentTemplateFilter>(
    client,
    '/document-management/DocumentTemplate',
    'id',
  );
}

export type DocumentTemplateService = CrudService<DocumentTemplate, DocumentTemplateCreate, DocumentTemplateFilter>;
